import React from 'react';
import { TextInput, Button } from '../../components';
import * as PATHS from '../../settings/paths';
import AuthWrapper from './AuthWrapper/AuthWrapper';

const ResendCode = () => {
  return (
    <AuthWrapper footer={{ description: "Don't have a account ?", linkName: 'Sign Up', link: PATHS.REGISTER }}>
      <TextInput placeholder={'Email Address'} />
      <TextInput placeholder={'Password'} />
      <Button full>{'Sign In'}</Button>
    </AuthWrapper>
  );
};

export default ResendCode;
